
import React from 'react';
import styles from './_composite-report.module.scss';
import ReportViewerDialog from '../../Dialogs/ReportViewerDialog/ReportViewerDialog';
import { BusinessTypes } from '../../../Helpers/Constants';

export interface CompositeReportProps {
  closeDialog: () => void;
  bearerToken: string;
  year: number;
  month: number;
  performanceGroup: string;
  baseUrl: string;
  reportTypeId: string;
}

export default function CompositeReport (props:  CompositeReportProps) {
  const { closeDialog, bearerToken, year, month, performanceGroup, baseUrl, reportTypeId} = props;
  const reportName = reportTypeId === BusinessTypes.bhph ? 'BHPHComposite.trbp' : reportTypeId === BusinessTypes.retail ? 'RetailComposite.trbp' : reportTypeId === BusinessTypes.finance ? 'FinanceComposite.trbp' : 'ServiceComposite.trbp';
  console.log('Billy - reportTypeId: ', reportTypeId, ' year: ', year, ' month: ', month, ' performanceGroup: ', performanceGroup, ' reportName: ', reportName);
  
  return (
    <ReportViewerDialog
      title={'Composite Report'}
      closeDialog={closeDialog}
      bearerToken={bearerToken}
      reportName={reportName}
      parameters={[
        {
          name: "ReportYear",
          value: `${year}`
        },
        {
          name: "ReportMonth",
          value: `${month}`
        },
        {
          name: "GroupCode",
          value: performanceGroup,
        }
      ]}
      baseUrl={baseUrl}
    />
  );
}
